import { render, staticRenderFns } from "./success-funding-wallet.vue?vue&type=template&id=3095c6d6&scoped=true"
import script from "./success-funding-wallet.vue?vue&type=script&lang=js"
export * from "./success-funding-wallet.vue?vue&type=script&lang=js"
import style0 from "./success-funding-wallet.vue?vue&type=style&index=0&id=3095c6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3095c6d6",
  null
  
)

export default component.exports